module.exports = __webpack_public_path__ + "static/media/R-330XLHD_CrossSection.91236452.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-330XLHD_CrossSection.png
// module id = 487
// module chunks = 0